import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageRefreshService {
  private readonly refreshSubject = new Subject<string>();
  readonly refresh$ = this.refreshSubject.asObservable();

  requestRefresh(url: string): void {
    this.refreshSubject.next(url);
  }
}
